// =============================================================================
// Template padrao da descricao de NF em modo Exterior (LLCs/USD)
// =============================================================================
// Texto especifico do faturamento de servicos publicitarios em USD.
// Replica LLCs (forceExterior=true) auto-preenche o campo descricao com
// este template a cada mudanca de data_competencia / valor_dolar / ptax /
// previsao_recebimento — exceto quando o usuario editou manualmente
// (controle e feito via ref no SolicitacaoForm).
// =============================================================================

const MONTH_NAMES_BR = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

function monthYearBR(iso) {
  if (!iso || typeof iso !== 'string') return '—';
  const [y, m] = iso.split('-');
  const idx = parseInt(m, 10) - 1;
  if (Number.isNaN(idx) || idx < 0 || idx > 11) return '—';
  return `${MONTH_NAMES_BR[idx]} de ${y}`;
}

function dateBR(iso) {
  if (!iso || typeof iso !== 'string') return '—';
  const [y, m, d] = iso.split('-');
  if (!y || !m || !d) return '—';
  return `${d}/${m}/${y}`;
}

function fmtPtax(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v <= 0) return '0,0000';
  return v.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
}

function fmtUSD(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v <= 0) return '0,00';
  return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Monta a descricao padrao LLCs.
 *
 * Campos esperados (todos opcionais — se faltar, sai com '—' / 0):
 *   dataPrestacao   ISO 'YYYY-MM-DD' (competencia)
 *   valorDolar      number
 *   ptax            number (4 casas)
 *   previsaoRec     ISO 'YYYY-MM-DD'
 */
export function buildExteriorDescricao({ dataPrestacao, valorDolar, ptax, previsaoRec }) {
  return [
    `Venda de espaço publicitário. Competência de ${monthYearBR(dataPrestacao)}`,
    `Valor em USD: ${fmtUSD(valorDolar)}`,
    `PTAX Compra de referência ${dateBR(dataPrestacao)} - R$ ${fmtPtax(ptax)}`,
    `Data de vencimento: ${dateBR(previsaoRec)}`,
    'NBS: 1.1406 - Serviços de propaganda e de alocação de espaço ou tempo para propaganda',
  ].join('\n');
}
